<template>
  <!-- 人群分析 -->
  <div class="analysisComp" v-if="show">
    <!-- 头部人群信息 -->
    <header class="headWrap">
      <div class="return">
        <span style="color: #999" @click="back">
          <i class="el-icon-arrow-left"></i> 返回列表</span
        >
        <span style="margin: 0 20px; color: #999">|</span>
        <span class="name">人群分析</span>
      </div>
      <div class="infoWrap">
        <p class="txt"><span></span> 人群概况</p>
        <div class="info">
          <div class="descBox">
            <!-- <div class="i"></div> -->
            <img src="@/assets/images/_big.png" alt="" class="i" />
            <div class="desc">
              <span
                style="display: flex; align-items: center; margin-bottom: 8px"
              >
                  <span
                    style="
                      width: 97px;
                      display: flex;
                      display: -webkit-box;
                      word-break: break-all;
                      text-overflow: ellipsis;
                      overflow: hidden;
                      -webkit-box-orient: vertical;
                      -webkit-line-clamp: 1;
                    "
                    >{{ crowdArray.name }}</span
                  >
                <span>
                  <el-rate
                    v-model="scoreValue"
                    disabled
                    text-color="#ff9900"
                    score-template="{value}"
                  >
                  </el-rate
                ></span>
                <el-popover
                  placement="top-start"
                  title="提示"
                  width="200"
                  trigger="hover"
                  content="依据官方算法，以转化率为主要判断依据，综合得出的人群评分"
                >
                  <img
                    src="@/assets/images/ask.png"
                    alt=""
                    class="imgItem"
                    slot="reference"
                  />
                </el-popover>
              </span>
              <!-- <span 
                >
              </span> -->
              <!-- <span>年龄:16-25岁 性别:女 总订单数:1~3</span> -->

              <template v-for="(item, index) in labelArr">
                <div :key="item.name" v-if="index < 3">
                  <!-- <span>{{ item.name }}:{{ item.value }}</span> -->
                  <el-tooltip
                    effect="light"
                    :content="item.valueStr"
                    placement="bottom-start"
                  >
                    <div class="over-ellipise">
                      {{ item.name }}:{{ item.value }}
                    </div>
                  </el-tooltip>
                </div>
              </template>
              <el-tooltip
                v-if="labelArr.length > 3"
                effect="light"
                :content="totalLabelStr"
                placement="bottom-start"
              >
                <div style="color: rgb(254, 77, 69); margin-top: 5px">更多</div>
              </el-tooltip>
              <span></span>
            </div>
          </div>
          <ul class="details">
            <li class="item">
              <span class="sp1">总人数</span>
              <span>{{ opdata_shop.total }}</span>
            </li>
            <li class="item">
              <span class="sp">近30天浏览过店铺</span>
              <span>{{ opdata_shop.opdata_shop_last30days_pv }}</span>
            </li>
            <li class="item">
              <span class="sp">近30天关注过商品</span>
              <span>{{
                opdata_shop.opdata_shop_last30days_follow_goods_num
              }}</span>
            </li>
            <li class="item">
              <span class="sp">近30天加购过商品</span>
              <span>{{ opdata_shop.opdata_shop_last30days_cart_num }}</span>
            </li>
            <li class="item">
              <span class="sp">近30天有下单</span>
              <span>{{ opdata_shop.opdata_shop_last30days_ord_num }}</span>
            </li>
            <!-- <li class="item2">
              <span class="sp"
                >人群评分
                <el-popover
                  placement="top-start"
                  title="提示"
                  width="200"
                  trigger="hover"
                  content="依据官方算法，以转化率为主要判断依据，综合得出的人群评分"
                >
                  <img
                    src="@/assets/images/ask.png"
                    alt=""
                    class="imgItem"
                    slot="reference"
                  /> </el-popover
              ></span>
              <span
                ><el-rate
                  v-model="scoreValue"
                  disabled
                  text-color="#ff9900"
                  score-template="{value}"
                >
                </el-rate
              ></span>
            </li> -->
          </ul>
        </div>
      </div>
    </header>
    <!-- 图表区域 -->
    <section class="section">
      <p class="txt"><span></span> 人群画像</p>
      <div style="padding: 23px 23px 10px 28px">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple echarts">性别</div>
            <div class="clos">
              <sex :ageNum="chartData.opdata_base_sex" v-if="ashow"></sex>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple echarts">年龄</div>
            <div class="clos">
              <!-- <occupation></occupation> -->
              <!-- <age :ageNum="chartData.opdata_base_age" v-if="ashow"></age> -->
              <age :year="chartData.opdata_base_age" v-if="ashow"></age>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple echarts">
              关注店铺（店铺粉丝）
            </div>
            <div class="clos">
              <page-order-money
                :resData="chartData.opdata_shop_follow_flag"
                v-if="ashow"
              ></page-order-money>
              <!-- <occupation></occupation> -->
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="padding: 23px 23px 10px 28px">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple echarts">已购+开卡用户会员</div>
            <div class="clos">
              <!-- <membership v-if="ashow"></membership> -->
              <page-order-money
                :resData="chartData.opdata_shop_member_flag"
                v-if="ashow"
              ></page-order-money>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple echarts">品牌会员</div>
            <div class="clos">
              <!-- <page-order-money></page-order-money> -->
              <page-order-money
                :resData="chartData.opdata_shop_brand_member_flag"
                v-if="ashow"
              ></page-order-money>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple echarts">婚姻状态</div>
            <div class="clos">
              <div id="order-care" :style="{ width: '100%', height: '300px' }">
                <page-order-money
                  :resData="chartData.opdata_base_marriage"
                  v-if="ashow"
                ></page-order-money>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="padding: 23px 23px 30px 28px">
        <el-row :gutter="20">
          <el-col :span="8">
            <div class="grid-content bg-purple echarts">是否有小孩</div>
            <div class="clos">
              <!-- <page-order-money></page-order-money> -->
              <page-order-money
                :resData="chartData.opdata_base_kids"
                v-if="ashow"
              ></page-order-money>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple echarts">店铺开卡会员</div>
            <div class="clos">
              <!-- <page-order-money></page-order-money> -->
              <page-order-money
                :resData="chartData.opdata_shop_card_member_flag"
                v-if="ashow"
              ></page-order-money>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content bg-purple echarts">店铺会员等级</div>
            <div class="clos">
              <div id="order-care">
                <!-- <page-order-money
                  :showLabel="false"
                  :resData="chartData.opdata_shop_member_level"
                  v-if="ashow"
                ></page-order-money> -->
                <membership
                  :level="chartData.opdata_shop_member_level"
                  v-if="ashow"
                ></membership>
                <!-- <page-order-money></page-order-money> -->
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- <ul class="chartList">
                <li class="chartItem" v-for="(item,index) in crowdArray.portrait" :key="index">
                    <p class="describe">性别</p>
                    <div class="chart">
                        <div style="height: 300px" :ref="'chart'+index"></div>
                    </div>
                </li>
            </ul> -->
    </section>
  </div>
</template>

<script>
import occupation from "../chart/occupation";
// import fans from "./chart/fans";
import pageOrderMoney from "../chart/page-order-money";
// import childrenHere from "../chart/children-Here";
import age from "../chart/age";
import sex from "../chart/sex";
import membership from "../chart/membership";
import { crowdAnalysis } from "@/api/manage/memberCrowdController";
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    sellerList: {
      // 商品类目数组
      type: Array,
      default: [],
    },
    crowdArray: null,
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          // console.log(this.crowdArray);
          this.setLabel(this.crowdArray);
          // const len = this.crowdArray.portrait.length;
          // for (let i = 0; i < len; i++) {
          //   this.chartsInit(
          //     this.$refs[`chart${i}`],
          //     ["未识别", "男", "女"],
          //     [
          //       { value: this.crowdArray.portrait, name: "未识别" },
          //       { value: 310, name: "男" },
          //       { value: 234, name: "女" },
          //     ]
          //   );
          // }
          this.init();
        });
      }
    },
  },
  data() {
    return {
      scoreValue: 0,
      chartList: ["", "", ""],
      opdata_shop: {},
      chartData: {
        opdata_base_sex: [],
        opdata_base_age: [],
      },
      ashow: false,
      labelArr: "",
      totalLabelStr: "",
    };
  },
  components: {
    pageOrderMoney,
    occupation,
    membership,
    age,
    sex,
  },
  created() {},

  mounted() {
    this.$nextTick(() => {
      this.setLabel(this.crowdArray);
      this.init();
    });
  },
  methods: {
    init() {
      this.ashow = false;
      this.chartData = {
        opdata_base_sex: [],
        opdata_base_age: [],
      };
      let crowd = {
        strategyId: this.crowdArray.strategyId,
        strategy: this.crowdArray.strategy,
      };
      crowdAnalysis(crowd)
        .then((res) => {
          this.opdata_shop = res.data;
          this.scoreValue = res.data.score;
          this.chartData.opdata_base_sex =
            res.data.portrait[0].labelPropertyList;
          this.chartData.opdata_base_age =
            res.data.portrait[0].labelPropertyList;
          this.chartData.opdata_shop_member_level =
            res.data.portrait[6].labelPropertyList;
          for (let item of res.data.portrait) {
            this.chartData[item.labelName] = item.labelPropertyList;
            this.chartData[item.labelName].labelMeaning = item.labelMeaning;
          }
          this.ashow = true;
        })
        .catch(() => {});
    },
    // 图表初始化
    chartsInit(ref, legend, data) {
      let myChart = this.$echarts.init(ref[0]);
      let options = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          data: legend,
          icon: "circle",
          left: "center",
          y: "bottom",
          textStyle: {
            fontSize: 12,
          },
        },
        color: ["#0D81FF", "#11CE99", "#F79D29"],
        series: [
          {
            name: "性别",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                //饼形图显示格式
                formatter: "{b|{b}}  {per|{d}%}  ",
                rich: {
                  b: {
                    color: "#333333",
                    fontSize: 14,
                    lineHeight: 33,
                  },
                  //设置百分比数字颜色
                  per: {
                    color: "#333333",
                    fontSize: 14,
                    padding: [2, 4],
                    borderRadius: 2,
                  },
                },
              },
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            data: data,
          },
        ],
      };
      myChart.setOption(options);
    },

    setLabel(data) {
      let labelList = JSON.parse(sessionStorage.getItem("labelList"));
      let strategy = JSON.parse(data.strategy);
      console.log(labelList);
      console.log('data.strategy:', JSON.parse(data.strategy));

      let labelArr = [];
      var totalLabelStr = "";
      for (let item of strategy) {
        let obj = {};
        
        let labelItem = labelList[item.tagname];
        obj.name = labelItem.name;
        // console.log('item.value====:', item.value)
        // console.log('labelItem.labelDisplayType====:', labelItem.labelDisplayType)
        switch (labelItem.labelDisplayType) {
          case 0:
            // 单选类型
            if (item.value) {
              if (!(item.value instanceof Array)) {
                item.value = [item.value]
              }
              console.log('item.value:', item.value)
              let radio = labelItem.enumValues.filter((lab) => {
              return item.value.includes(lab.realValue);
              });
              let strRadio = "";
              radio.map((i) => {
                strRadio = strRadio + i.fieldValue + " ";
              });
              obj.value = strRadio;
            }
            // console.log(checked);
            break;
          case 1:
            let checked = labelItem.enumValues.filter((lab) => {
              return item.value.includes(lab.realValue);
            });
            // console.log(checked);
            // return
            let str = "";
            checked.map((i) => {
              str = str + i.fieldValue + " ";
            });
            obj.value = str;
            console.log(obj.value);
            break;

          case 5:
            obj.value = item.value.join(",");
            break;
          case 6:
            // 三级类目
            let sellerCat = this.sellerList.filter((lab) => {
              return item.value.includes(lab.categoryId);
            });
            let strSeller = "";
            sellerCat.map((i) => {
              strSeller += i.name + " ";
            });
            obj.value = strSeller;
            break;
          case 7:
            let cityArr = JSON.parse(sessionStorage.getItem("cityArr"));
            // let str = "";
            let res = item.value.map((i) => {
              let name =
                cityArr[cityArr.findIndex((ele) => ele.title == i)].name;
              // console.log(name);
              return name;
            });
            obj.value = res.join(",");
            break;
        }
        if (
          labelItem.labelDisplayType == 3 ||
          labelItem.labelDisplayType == 4
        ) {
          console.log("item:", item);
          if (item.timeSelectType == "1") {
            obj.value = "大于等于" + item.startValue;
          } else if (item.timeSelectType == "2") {
            obj.value = "小于等于" + item.endValue;
          } else if (item.timeSelectType == "4") {
            obj.value = item.value;
          } else if (
            item.timeSelectType == "3" ||
            labelItem.labelDisplayType == 3
          ) {
            // 相对时间
            if (item.startValue && item.endValue) {
              obj.value = item.startValue + " 至 " + item.endValue;
            } else if (item.startValue) {
              obj.value = "大于" + item.startValue;
            } else if (item.endValue) {
              obj.value = "小于" + item.endValue;
            }
          } else {
            obj.value = item.startValue + " ~ " + item.endValue;
          }
        }

        obj.valueStr = obj.name + ":" + obj.value;
        totalLabelStr += obj.valueStr + ";";
        labelArr.push(obj);
      }

      // console.log(labelArr);
      // this.labelArr = labelArr.slice(0, 4);
      this.labelArr = labelArr;
      this.totalLabelStr = totalLabelStr;
    },

    // 返回
    back() {
      this.$emit("back");
    },
  },
};
</script>

<style scoped lang="scss">
.analysisComp {
  .headWrap {
    background-color: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .return {
      box-sizing: border-box;
      padding-left: 24px;
      height: 50px;
      line-height: 49px;
      border-bottom: 1px solid #f3f3f3;
      span {
        &:first-child {
          cursor: pointer;
        }
      }
    }
    .infoWrap {
      box-sizing: border-box;
      padding: 20px 28px 30px;
      .txt {
        margin-bottom: 20px;
      }
      .info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 24px 0 24px 32px;
        border: 1px solid #eeeeee;
        border-radius: 4px;
        .descBox {
          display: flex;
          align-items: center;
          flex-shrink: 0;
          flex-grow: 0;
          @media screen and (max-width: 1370px) {
            margin-right: -35px;
          }
          .over-ellipise {
            width: 250px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .i {
            width: 74px;
            height: 74px;
            margin-right: 20px;
            background: #fff9f3;
            // linear-gradient(
            //   321deg,
            //   rgba(254, 203, 144, 1) 0%,
            //   rgb(255, 243, 229) 100%
            // );
            border-radius: 50%;
            // opacity: 0.2;
          }
          .desc {
            display: flex;
            flex-direction: column;
            span {
              &:first-child {
                // margin-bottom: 8px;
                color: #333;
                font-size: 16px;
                font-weight: 500;
              }
              &:last-child {
                color: #666;
                font-size: 13px;
                font-weight: 400;
              }
            }
          }
        }
        .details {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .item {
            margin-right: 8px;
            display: flex;
            flex-direction: column;
            width: 24%;
            @media screen and (max-width: 1370px) {
              width: 110px;
            }
            font-size: 14px;
            font-weight: 400;
            color: #333;
            .sp {
              margin-bottom: 8px;
              @media screen and (max-width: 1370px) {
                width: 80px;
              }
            }
            .sp1 {
              margin-bottom: 8px;
              @media screen and (max-width: 1370px) {
                width: 80px;
                margin-bottom: 20px;
              }
            }
            span {
              // white-space: nowrap;
              &:first-child {
                color: #999;
                font-size: 14px;
              }
              &:last-child {
                font-size: 24px;
                color: #fe4d45;
                &::after {
                  content: "人";
                  font-size: 14px;
                  color: #999;
                }
              }
            }
          }
          .item2 {
            display: flex;
            flex-direction: column;
            width: 26%;
            font-size: 14px;
            font-weight: 400;
            margin: -8px 0 0 -25px;
            color: #999999;
            .sp {
              margin-bottom: 8px;
              @media screen and (max-width: 1370px) {
                margin-left: 8px;
                margin-bottom: 20px;
              }
            }
            .imgItem {
              cursor: pointer;
            }
          }
        }
      }
    }
  }
  .section {
    box-sizing: border-box;
    padding: 20px 28px 30px;
    margin-top: 20px;
    background: #fff;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .chartList {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .chartItem {
        width: 33%;
        height: 350px;
        border: 1px solid #f3f4f7;
        .describe {
          height: 40px;
          line-height: 40px;
          box-sizing: border-box;
          padding-left: 20px;
          margin: 0;
          background-color: #fafafa;
          color: #333;
          font-size: 14px;
          font-weight: 500;
        }
        .chart {
          height: 310px;
        }
      }
    }
    .echarts {
      width: 100%;
      height: 40px;
      background: #fafafa;
      opacity: 1;
      padding-left: 20px;
      line-height: 40px;
    }
    .clos {
      width: 100%;
      height: 310px;
      @media screen and (max-width: 1370px) {
        height: 250px !important;
      }
      @media screen and (max-width: 1300px) {
        height: 220px !important;
      }
      background: #ffffff;
      border: 1px solid #f3f4f7;
      opacity: 1;
      padding-left: 20px;
    }
  }
  .txt {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding-left: 12px;
    line-height: 32px;
    background-color: #fafafa;
    span {
      width: 2px;
      height: 14px;
      margin-right: 6px;
      background-color: #fe4d45;
    }
  }
}
</style>
